import * as React from "react";
import styles from "./loader.module.scss";

export const Loader = () => <div className={styles.loader}/>